import React from "react";
import { Header, Tab, Table } from "semantic-ui-react";

export const PaneTerms = (props) => {
  const { additionalCost, taxState, term } = props;

  return (
    <Tab.Pane>
      <Header content="Contract Terms" />
      <Table celled compact striped color="green">
        <Table.Body>
          <Table.Row>
            <Table.Cell content="Term Length" />
            <Table.Cell
              content={`${term && term.term ? `${term.term} months` : ""}`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Tax State" />
            <Table.Cell content={`${term && taxState ? taxState : ""}`} />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Tax Rate" />
            <Table.Cell
              content={`${term && term.tax_rate ? term.tax_rate : ""}%`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Cost of Unit (Cash Price)" />
            <Table.Cell
              content={`${
                term.total_hvac_system_cost
                  ? `$${term.total_hvac_system_cost}`
                  : ""
              }`}
            />
          </Table.Row>
          {/* <Table.Row>
            <Table.Cell content="Additional Installation Materials" />
            <Table.Cell content={additionalCost ? `$${additionalCost}` : '$0.00'} />
          </Table.Row> */}
          <Table.Row>
            <Table.Cell content="Cash Total" />
            <Table.Cell
              content={`$${term && term.cash_total ? term.cash_total : ""}`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Minimum Cost Reduction" />
            <Table.Cell
              content={`$${
                term && term.minimum_purchase_reserve
                  ? term.minimum_purchase_reserve
                  : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Additional Cost Reduction" />
            <Table.Cell
              content={`$${
                term && term.additional_purchase_reserve
                  ? term.additional_purchase_reserve
                  : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Total Cost Reduction" />
            <Table.Cell
              content={`$${
                term && term.total_purchase_reserve
                  ? term.total_purchase_reserve
                  : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Tax On Deposit" />
            <Table.Cell
              content={`$${
                term && term.tax_on_deposit ? term.tax_on_deposit : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Final Cost of Unit" />
            <Table.Cell
              content={`$${
                term && term.final_cost_of_unit ? term.final_cost_of_unit : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Cost Reduction After Tax" />
            <Table.Cell
              content={`$${
                term && term.cost_reduction_after_tax
                  ? term.cost_reduction_after_tax
                  : ""
              }`}
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Total Monthly Payment" />
            <Table.Cell
              content={`$${
                term && term.total_monthly_payment
                  ? term.total_monthly_payment
                  : ""
              }/mo.`}
            />
          </Table.Row>
        </Table.Body>
      </Table>
    </Tab.Pane>
  );
};
